module.exports = __webpack_public_path__ + "img/grop.c9886a42.png";